<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: Consultant shell of the contract page's „Standard“ navigation (inherits the logic of
    CmContractStandardNavigationComponent). Hosts, like the standard shell, the „Beitragsaussetzungen“
    table with its row actions, the „Beitragsaussetzung bearbeiten“ dialog around the GENERIC form
    (mvs-crud-object, update only; delete removed and start/end/reason read-only once reported) and the
    „An Versicherer gemeldet …“ dialog — plus the two price wizard dialogs of this shell.
-->
<ng-container *ngIf="initialized">
  <div class="grid">

    <div class="lg:col-3 col-12 px-1">

      <mvs-widget class="mb-3 block" *ngIf="contractWidgetData"
                  [widgetData]="contractWidgetData"
                  [disableUpdate]="disableUpdate"
      >
      </mvs-widget>

      <mvs-widget class="mb-3 block" *ngIf="customerContractWidgetData"
                  [widgetData]="customerContractWidgetData"
                  [disableUpdate]="disableUpdate"
      >
      </mvs-widget>

      <mvs-widget class="mb-3 block" *ngIf="myWidget"
                  [widgetData]="myWidget"
                  [disableUpdate]="disableUpdate"
      >
      </mvs-widget>

      <mvs-widget class="mb-3 block" *ngIf="contractFormerWidgetData"
                  [widgetData]="contractFormerWidgetData"
                  [disableUpdate]="disableUpdate"
      >
      </mvs-widget>

      <mvs-widget class="mb-3 block" *ngIf="contractDataWidgetData"
                  [widgetData]="contractDataWidgetData"
                  [disableUpdate]="disableUpdate"
      >
      </mvs-widget>

      <div>
        <mvs-object-tags
          headline="Tags"
          [mainObject]="objectIdentifier"
          linkedEntityObjectType="cm.ContractTag"
          [readOnly]="true"
        ></mvs-object-tags>
      </div>

    </div>

    <div class="lg:col-9 col-12">

      <div class="grid">

        <div class="lg:col-6 col-12">

          <mvs-widget class="mb-3 block" *ngIf="contractPartnerWidgetData"
                      [widgetData]="contractPartnerWidgetData"
                      [disableUpdate]="disableUpdate"
          >
          </mvs-widget>


          <mvs-widget class="mb-3 block" *ngIf="contractPriceWidgetData"
                      [widgetData]="contractPriceWidgetData"
                      [widgetToolbarButtons]="priceToolbarButtons"
                      (onToolbarButtonClick)="handlePriceToolbarClick($event)"
                      [disableUpdate]="disableUpdate"
          >
          </mvs-widget>

          <!--
            Beitragsaussetzungen (cm.ContractPaymentSuspension), requirement 6.1 — same widget, columns
            and row actions as the standard shell (built by the inherited refreshWidgets(), alias with
            the ':co' suffix). [disableUpdate]="true" removes the generic „Anlegen“: a suspension is
            created through the „Beitrag aussetzen“ wizard only.
          -->
          @if (contractPaymentSuspensionWidgetData) {
            <mvs-widget class="mb-3 block"
                        [widgetData]="contractPaymentSuspensionWidgetData"
                        [disableUpdate]="true">

              <ng-template mvs-widget-custom-field-directive area="columns"
                           fieldId="paymentResumeDate" label="Wiederbeginn der Zahlung"
                           let-object="object">
                @if (paymentSuspensionResumeDate(object); as resumeDate) {
                  <span>{{ resumeDate | date:'dd.MM.yyyy' }}</span>
                } @else {
                  <span class="text-color-secondary">–</span>
                }
              </ng-template>

              <ng-template mvs-widget-custom-field-directive area="columns"
                           fieldId="suspendedMonths" label="Monate"
                           let-object="object">
                <span>{{ paymentSuspensionMonths(object) ?? '–' }}</span>
              </ng-template>

              <ng-template mvs-widget-custom-field-directive area="columns"
                           fieldId="reportedAt" label="An Versicherer gemeldet am"
                           let-object="object">
                @if (paymentSuspensionReportedAt(object); as reportedAt) {
                  <span class="flex align-items-center gap-2">
                    <i class="fa-regular fa-lock text-color-secondary"
                       pTooltip="Gemeldet: Beginn, Ende und Grund sind gesperrt, Löschen ist nicht möglich."
                       tooltipPosition="top"></i>
                    <span>{{ reportedAt | date:'dd.MM.yyyy' }}</span>
                  </span>
                } @else {
                  <span class="text-color-secondary">–</span>
                }
              </ng-template>

              <ng-template mvs-widget-custom-field-directive area="columns"
                           fieldId="actions" label="Aktionen"
                           let-object="object">
                <div class="flex align-items-center gap-1" (click)="$event.stopPropagation()">
                  @if (canWritePaymentSuspension) {
                    <p-button icon="fa-regular fa-pen-to-square"
                              [text]="true" [rounded]="true" severity="secondary" size="small"
                              [ariaLabel]="isPaymentSuspensionReported(object) ? 'Kommentar bearbeiten' : 'Bearbeiten'"
                              [pTooltip]="isPaymentSuspensionReported(object) ? 'Kommentar bearbeiten (Beginn, Ende und Grund sind nach der Meldung gesperrt)' : 'Bearbeiten'"
                              tooltipPosition="top"
                              (onClick)="openPaymentSuspensionEdit(object)"></p-button>
                  }
                  @if (canWritePaymentSuspension && !isPaymentSuspensionReported(object)) {
                    <p-button icon="fa-regular fa-paper-plane"
                              [text]="true" [rounded]="true" severity="secondary" size="small"
                              ariaLabel="An Versicherer gemeldet …"
                              pTooltip="An Versicherer gemeldet …"
                              tooltipPosition="top"
                              (onClick)="openPaymentSuspensionReporting(object)"></p-button>
                  }
                  @if (canResetPaymentSuspensionReportingState && isPaymentSuspensionReported(object)) {
                    <p-button icon="fa-regular fa-rotate-left"
                              [text]="true" [rounded]="true" severity="danger" size="small"
                              ariaLabel="Meldestand zurücksetzen"
                              pTooltip="Meldestand zurücksetzen"
                              tooltipPosition="top"
                              [loading]="paymentSuspensionResetBusyId === paymentSuspensionId(object)"
                              (onClick)="confirmPaymentSuspensionReportingReset(object)"></p-button>
                  }
                </div>
              </ng-template>
            </mvs-widget>
          }

          <mvs-widget class="mb-3 block" *ngIf="contractOneTimePaymentWidgetData"
                      [widgetData]="contractOneTimePaymentWidgetData"
                      [disableUpdate]="disableUpdate"
          >
          </mvs-widget>

          <mvs-widget class="mb-3 block" *ngIf="contractPaymentWidgetData"
                      [widgetData]="contractPaymentWidgetData"
                      [disableUpdate]="disableUpdate"
          >
          </mvs-widget>

          <mvs-widget *ngIf="contractLabelWidget"
                      [widgetData]="contractLabelWidget"
                      [disableUpdate]="disableUpdate">
          </mvs-widget>

        </div>

        <div class="lg:col-6 col-12">


          <mvs-widget class="mb-3 block" *ngIf="contractAgentWidgetData"
                      [widgetData]="contractAgentWidgetData"
                      [disableUpdate]="disableUpdate"
          >
          </mvs-widget>

          <!-- Document Comments-->
          <mvs-widget class="mb-3 block" *ngIf="ticketWidget"
                      [widgetData]="ticketWidget"
                      (onObjectSelect)="handleTicketSelect($event)"
                      [disableUpdate]="disableUpdate">
          </mvs-widget>

          <mvs-object-comments
            class="mvs-widget p-0 block"
            headline="Kommentare/ Vetragsinformationen"
            [mainObject]="objectIdentifier"
            linkedEntityObjectType="cm.ContractComment"
          ></mvs-object-comments>

        </div>

      </div>


    </div>


  </div>

  <!--
    AI:
    Status: "in progress"
    Type: Component
    SubType: CrudIntegration
    Reason: Preisänderung dialog, mirroring the standard shell. Hosts the guided wizard for a new
      running premium on this contract; the dialog only owns visibility and size. Opened from the
      "Laufende Beiträge" toolbar action 'open-price-change-wizard'
      (CmContractStandardNavigationComponent#handlePriceToolbarClick).

    TM-1000002003 — EVERY EXIT OF THIS DIALOG IS FUNNELLED, mirroring the standard shell's
    cm-contract-quick-actions. This shell was a LIVE BYPASS of a guard the other shell already
    honoured, and a guard one shell honours and another ignores is worse than no guard.
    [visible] is ONE-WAY, so the dialog cannot close itself: PrimeNG's X, Escape and mask all
    report through (visibleChange), which is routed into the close guard. Nothing but
    handlePriceChangeWizardClose() may lower the flag.
  -->
  <p-dialog
    [visible]="dialogPriceChangeWizard"
    [modal]="true"
    [style]="{width: '76rem', height: '85vh'}"
    [contentStyle]="{overflow: 'auto'}"
    [resizable]="false"
    [draggable]="false"
    (visibleChange)="requestPriceChangeWizardClose()"
    header="Preisänderung">

    <cm-price-change-wizard
      *ngIf="dialogPriceChangeWizard"
      [importObjectContext]="dtoImportObjectContext"
      (onDialogClose)="handlePriceChangeWizardClose()">
    </cm-price-change-wizard>

  </p-dialog>

  <!--
    AI:
    Status: "in progress"
    Type: Component
    SubType: CrudIntegration
    Reason: Beitrag aussetzen dialog, mirroring the standard shell. Hosts the guided wizard for a
      Beitragsaussetzung (cm.ContractPaymentSuspension, mandatory end); the permanent
      Beitragsfreistellung lives in the Preisänderung wizard (F2/D1). The dialog only owns
      visibility and size. Opened from the "Laufende Beiträge" toolbar action
      'open-payment-pause-wizard'.

    TM-1000002003 — EVERY EXIT OF THIS DIALOG IS FUNNELLED, same contract and same reason as the
    Preisänderung dialog above: [visible] is ONE-WAY, so PrimeNG's X, Escape and mask all report
    through (visibleChange), which is routed into handlePaymentPauseWizardClose()'s guard.
  -->
  <p-dialog
    [visible]="dialogPaymentPauseWizard"
    [modal]="true"
    [style]="{width: '76rem', height: '85vh'}"
    [contentStyle]="{overflow: 'auto'}"
    [resizable]="false"
    [draggable]="false"
    (visibleChange)="requestPaymentPauseWizardClose()"
    header="Beitrag aussetzen">

    <cm-payment-pause-wizard
      *ngIf="dialogPaymentPauseWizard"
      [importObjectContext]="dtoImportObjectContext"
      (onDialogClose)="handlePaymentPauseWizardClose()">
    </cm-payment-pause-wizard>

  </p-dialog>

  <!--
    Beitragsaussetzung bearbeiten — same contract as in the standard shell: the GENERIC form of
    cm.ContractPaymentSuspension; a reported suspension opens with start, end and reason read-only and
    without delete (V10, D22). [visible] is one-way; X / Escape close through closePaymentSuspensionEdit().
  -->
  <p-dialog
    [visible]="!!paymentSuspensionEditId"
    (visibleChange)="closePaymentSuspensionEdit()"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{width: '48rem'}"
    header="Beitragsaussetzung bearbeiten">
    @if (paymentSuspensionEditId && paymentSuspensionEditReported) {
      <p-message severity="info" styleClass="w-full mb-3">
        Bereits an den Versicherer gemeldet: Beginn, Ende und Grund sind gesperrt, nur der Kommentar
        ist änderbar. Korrekturen und Löschen erst nach Klärung mit dem Versicherer und dem
        Zurücksetzen des Meldestands.
      </p-message>
    }
    @if (paymentSuspensionEditId) {
      <!-- AI: CrudIntegration — generic update form of cm.ContractPaymentSuspension (no create) -->
      <mvs-crud-object [objectType]="'cm.ContractPaymentSuspension'"
                       [objectId]="paymentSuspensionEditId"
                       [formControlOverwrite]="paymentSuspensionEditFormControlOverwrite"
                       [removeDelete]="paymentSuspensionEditReported"
                       (onChangedObject)="handlePaymentSuspensionEdited($event)">
      </mvs-crud-object>
    }
  </p-dialog>

  <!-- „An Versicherer gemeldet …“ (D20): open while paymentSuspensionReportingTarget is set -->
  <cm-payment-suspension-reporting-dialog
    [suspension]="paymentSuspensionReportingTarget"
    (onClose)="closePaymentSuspensionReporting()">
  </cm-payment-suspension-reporting-dialog>
</ng-container>
